import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import EfSpec from '@elem/ui/ef-spec';
import css from './index.module.scss';

let sceneTextEnterQ: any = null,
    sceneTextLeaveQ: any = null;
export default function Q() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const SITE_JP = 'jp';
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    const cards: any[] =
        locale === SITE_JP
            ? [
                  {
                      img: '/responsive/picture/delta-pro-ultra/launch/17_1',
                      text: t('secQ_card1_text'),
                  },
                  {
                      img: '/responsive/picture/delta-pro-ultra/launch/17_3',
                      text: t('secQ_card3_text'),
                  },
              ]
            : EU_SITES.includes(locale)
            ? [
                  {
                      img: 'https://websiteoss.ecoflow.com/upload/image/1750833014386/img1.png',
                      text: t('secQ_card1_text'),
                  },
                  {
                      img: 'https://websiteoss.ecoflow.com/upload/image/1750833014053/img2.png',
                      text: t('secQ_card2_text'),
                  },
                  {
                      img: 'https://websiteoss.ecoflow.com/upload/image/1750833014206/img3.png',
                      text: t('secQ_card3_text'),
                  },
              ]
            : [
                  {
                      img: '/responsive/picture/delta-pro-ultra/launch/17_1',
                      text: t('secQ_card1_text'),
                  },
                  {
                      img: '/responsive/picture/delta-pro-ultra/launch/17_2',
                      text: t('secQ_card2_text'),
                  },
                  {
                      img: '/responsive/picture/delta-pro-ultra/launch/17_3',
                      text: t('secQ_card3_text'),
                  },
              ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterQ) {
                    AniContainer.removeScene(sceneTextEnterQ);
                    sceneTextEnterQ = null;
                }
                if (sceneTextLeaveQ) {
                    AniContainer.removeScene(sceneTextLeaveQ);
                    sceneTextLeaveQ = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                // const isOnlyH5 = window?.innerWidth < 768;
                const textTarget = document.querySelector('.dpu-detail-Q .text-info') as HTMLElement;
                if (textTarget) {
                    sceneTextEnterQ = AniContainer.create({
                        triggerElement: '.dpu-detail-Q .text-info',
                        triggerHook: 1,
                        offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                        duration: 200, // window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                        onEnter: () => setTextEnter(true),
                        //onLeave: () => setTextEnter(false),
                    });
                    // sceneTextLeaveQ = AniContainer.create({
                    //     triggerElement: '.dpu-detail-Q .text-info',
                    //     triggerHook: 1,
                    //     offset: 0,
                    //     duration: window.innerHeight * 2,
                    //     onLeave: () => setTextEnter(false),
                    // });
                }
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterQ) {
                    AniContainer.removeScene(sceneTextEnterQ);
                    sceneTextEnterQ = null;
                }
                if (sceneTextLeaveQ) {
                    AniContainer.removeScene(sceneTextLeaveQ);
                    sceneTextLeaveQ = null;
                }

                //window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-Q dpu-detail-section ${css['dpu-detail-Q']}`}>
            <EfSpec />
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h2 className="title">{t('secQ_title')}</h2>
                <p className="desc">
                    {t.rich('secQ_desc', {
                        w: (text: string) => <span className="white">{text}</span>,
                    })}
                </p>
            </div>
            <div className="cards-box">
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            {EU_SITES.includes(locale) ? (
                                <EFPicture src={`${card?.img}`} srcPad={`${card?.img}`} srcMobile={`${card?.img}`} alt={card?.text} />
                            ) : (
                                <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_768.jpg`} srcMobile={`${card?.img}_768.jpg`} alt={card?.text} />
                            )}
                            <p className="card-text">{card?.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
